import { Role } from '../../enums/role.enum';

export const ROLE = {
  [Role.Admin]: 'ADMIN',
  [Role.Employee]: 'EMPLOYEE',
  [Role.Student]: 'STUDENT',
  [Role.Parent]: 'PARENT',
  [Role.Candidate]: 'CANDIDATE',
};
